import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
    Box, Card, Heading, Text, Flex, Separator, TextField, Select, Button, Callout
} from "@radix-ui/themes";
import { getTotal } from "../cart/cart";
import { PAYMENT, SHIPPING } from "../api/config";

function fmt(n) {
    return new Intl.NumberFormat("sk-SK", { style: "currency", currency: "EUR" }).format(n || 0);
}
function loadInitial() {
    try { var raw = localStorage.getItem("customer_v1"); return raw ? JSON.parse(raw) : null; }
    catch(e){ return null; }
}
function saveCustomer(data) { localStorage.setItem("customer_v1", JSON.stringify(data)); }
function validateEmail(s){ return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(s||"").trim()); }
function validatePhone(s){ return /^[+\d][\d\s\-()]{6,}$/.test(String(s||"").trim()); }
function validatePSC(s){ return /^\d{3}\s?\d{2}$/.test(String(s||"").trim()); }
function loadCheckout(){
    try { var raw = localStorage.getItem("checkout_v1"); return raw ? JSON.parse(raw) : null; }
    catch(e){ return null; }
}

export default function CustomerFormPage() {
    var navigate = useNavigate();

    // údaje zákazníka
    var init = loadInitial() || { firstName:"", lastName:"", email:"", phone:"", address:"", city:"", psc:"", country:"sk" };
    var [form, setForm] = useState(init);
    var [errors, setErrors] = useState({});

    // súhrn doprava/platba
    var checkout = loadCheckout() || { ship: "kurier", pay: "kartou" };
    var shipCfg = SHIPPING[checkout.ship] || SHIPPING.kurier;
    var payCfg  = PAYMENT[checkout.pay]   || PAYMENT.kartou;

    var subtotal = getTotal();
    var shipping = shipCfg.price;
    var payment  = payCfg.price;
    var total    = subtotal + shipping + payment;

    function onChange(field, value) {
        setForm(function(prev){ var o = Object.assign({}, prev); o[field] = value; return o; });
    }
    function handleCountryChange(value){ onChange("country", value); }

    function validate() {
        var e = {};
        if (!form.firstName.trim())     e.firstName = "Zadajte meno.";
        if (!form.lastName.trim())      e.lastName  = "Zadajte priezvisko.";
        if (!validateEmail(form.email)) e.email  = "Zadajte platný e-mail.";
        if (!validatePhone(form.phone)) e.phone  = "Zadajte platné tel. číslo.";
        if (!form.address.trim())       e.address = "Zadajte adresu.";
        if (!form.city.trim())          e.city    = "Zadajte mesto.";
        if (!validatePSC(form.psc))     e.psc     = "Zadajte PSČ v správnom formáte.";
        if (!form.country)              e.country = "Vyberte štát.";
        setErrors(e);
        return Object.keys(e).length === 0;
    }
    function handleSubmit(ev){
        ev.preventDefault();
        if (!validate()) return;
        saveCustomer(form);
        navigate("/zhrnutie");
    }

    var hasCheckout = !!loadCheckout();

    return (
        <div className="container py-4">
            {/*<h1 className="h4 mb-4">Údaje zákazníka</h1>*/}
            {!hasCheckout && (
                <Callout.Root color="amber" mb="3">
                    <Callout.Text>Tip: najprv zvoľte dopravu a platbu na stránke <Link to="/objednavka">objednávka</Link>.</Callout.Text>
                </Callout.Root>
            )}

            <div className="row g-4">
                {/* ĽAVO – FORM */}
                <div className="col-lg-8">
                    <Card>
                        <form onSubmit={handleSubmit}>
                            <Box p="4">
                                <Heading size="4" mb="2">Kontaktné údaje</Heading>
                                <Flex gap="3" direction={{ initial: "column", sm: "row" }}>
                                    <Box style={{ flex: 1 }}>
                                        <Text as="label" size="2" mb="1" style={{ display:"block" }}>Meno</Text>
                                        <TextField.Root
                                            value={form.firstName}
                                            name="FirstName"
                                            onChange={function(e){ onChange("firstName", e.target.value); }}
                                            placeholder="Jožko" />
                                        {errors.firstName && <Text color="red" size="1">{errors.firstName}</Text>}
                                    </Box>
                                    <Box style={{ flex: 1 }}>
                                        <Text as="label" size="2" mb="1" style={{ display:"block" }}>Priezvisko</Text>
                                        <TextField.Root
                                            value={form.lastName}
                                            name="LastName"
                                            onChange={function(e){ onChange("lastName", e.target.value); }}
                                            placeholder="Mrkvička" />
                                        {errors.lastName && <Text color="red" size="1">{errors.lastName}</Text>}
                                    </Box>
                                </Flex>

                                <Flex gap="3" mt="3" direction={{ initial: "column", sm: "row" }}>
                                    <Box style={{ flex: 1 }}>
                                        <Text as="label" size="2" mb="1" style={{ display:"block" }}>E-mail</Text>
                                        <TextField.Root
                                            type="email"
                                            name="email"
                                            value={form.email}
                                            onChange={function(e){ onChange("email", e.target.value); }}
                                            placeholder="jozko.mrkvicka@gmail.com" />
                                        {errors.email && <Text color="red" size="1">{errors.email}</Text>}
                                    </Box>
                                    <Box style={{ flex: 1 }}>
                                        <Text as="label" size="2" mb="1" style={{ display:"block" }}>Tel. číslo</Text>
                                        <TextField.Root
                                            value={form.phone}
                                            name="phone"
                                            type="tel"
                                            onChange={function(e){ onChange("phone", e.target.value); }}
                                            placeholder="+421 900 123 456" />
                                        {errors.phone && <Text color="red" size="1">{errors.phone}</Text>}
                                    </Box>
                                </Flex>

                                <Separator size="4" mt="5" mb="4" />

                                <Heading size="4" mb="2">Adresa doručenia</Heading>
                                <Box>
                                    <Text as="label" size="2" mb="1" style={{ display:"block" }}>Adresa</Text>
                                    <TextField.Root
                                        value={form.address}
                                        name="address"
                                        onChange={function(e){ onChange("address", e.target.value); }}
                                        placeholder="Pod mostom 43" />
                                    {errors.address && <Text color="red" size="1">{errors.address}</Text>}
                                </Box>

                                <Flex gap="3" mt="3" direction={{ initial: "column", sm: "row" }}>
                                    <Box style={{ flex: 3 }}>
                                        <Text as="label" size="2" mb="1" style={{ display:"block" }}>Mesto</Text>
                                        <TextField.Root
                                            value={form.city}
                                            name="city"
                                            onChange={function(e){ onChange("city", e.target.value); }}
                                            placeholder="Bratislava" />
                                        {errors.city && <Text color="red" size="1">{errors.city}</Text>}
                                    </Box>
                                    <Box style={{ flex: 2 }}>
                                        <Text as="label" size="2" mb="1" style={{ display:"block" }}>PSČ</Text>
                                        <TextField.Root
                                            value={form.psc}
                                            name="zip"
                                            maxLength="6"
                                            onChange={function(e){ onChange("psc", e.target.value); }}
                                            placeholder="987 65" />
                                        {errors.psc && <Text color="red" size="1">{errors.psc}</Text>}
                                    </Box>
                                    <Box style={{ flex: 1 }}>
                                        <Text as="label" size="2" mb="1" style={{ display:"block" }}>Štát</Text>
                                        <Select.Root value={form.country} onValueChange={handleCountryChange}>
                                            <Select.Trigger />
                                            <Select.Content>
                                                <Select.Item value="sk">Slovensko (SK)</Select.Item>
                                                <Select.Item value="cz">Česko (CZ)</Select.Item>
                                            </Select.Content>
                                        </Select.Root>
                                        {errors.country && <Text color="red" size="1">{errors.country}</Text>}
                                    </Box>
                                </Flex>

                                <Flex justify="between" align="center" mt="4" gap="3">
                                    <Link to="/objednavka" className="btn btn-outline-secondary rounded-pill">← Späť</Link>
                                    <Button className="btn btn-brown" type="submit" size="3">Zhrnutie</Button>
                                </Flex>
                            </Box>
                        </form>
                    </Card>
                </div>

                {/* PRAVO – SÚHRN */}
                <div className="col-lg-4">
                    <div className="card">
                        <div className="card-body">
                            <div className="d-flex justify-content-between mb-2">
                                <span>Medzisúčet</span><span className="fw-semibold">{fmt(subtotal)}</span>
                            </div>
                            <div className="d-flex justify-content-between mb-2">
                                <span>Doprava ({shipCfg.label})</span><span>{fmt(shipping)}</span>
                            </div>
                            <div className="d-flex justify-content-between mb-2">
                                <span>Platba ({payCfg.label})</span><span>{fmt(payment)}</span>
                            </div>
                            <hr />
                            <div className="d-flex justify-content-between">
                                <span className="fw-bold">Spolu</span>
                                <span className="fw-bold fs-5">{fmt(total)}</span>
                            </div>
                            <Link to="/objednavka" className="btn btn-link p-0 mt-2">Zmeniť dopravu/platbu</Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
